import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import PropTypes from 'prop-types';
import { Field, ErrorMessage } from 'formik';
import { FormGroup, Label } from 'reactstrap';
import { getProjectStatus as onGetProjectStatus } from 'store/actions';
import SafeField from "helpers/SafeField";

const ProjectStatusOption = ({ name, errors, touched }  ) => {
    const dispatch = useDispatch();
    const { docstatuses } = useSelector(state => ({
      docstatuses: state.AppoinmentObject.docstatuses,
      }));
      useEffect(() => {
        dispatch(onGetProjectStatus(localStorage.getItem("userId")));
    }, [dispatch, onGetProjectStatus]);
  
    return (
      <FormGroup className="mb-3">
        <Label htmlFor={name}>Status *</Label>
        <SafeField as="select" name={name} 
        className={
          "form-control" +
          (errors.projectType && touched.projectType
            ? " is-invalid"
            : "")
        }
        >
          <option value="">Select</option>
          {docstatuses.map((option) => (
            <option key={option.id} value={option.id}>
              {option.projectStatusTitle}
            </option>
          ))}
        </SafeField>
        <ErrorMessage name={name} component="div" className="invalid-feedback" />
      </FormGroup>
    );
  };  
  ProjectStatusOption.propTypes = {
    name:PropTypes.object,
    errors: PropTypes.object,
    touched: PropTypes.object
  };
export default ProjectStatusOption;
